module.exports = __webpack_public_path__ + "static/media/filter_conces.163a22bb.svg";